"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validationReducer = exports.initialValidationState = exports.validationActions = exports.ValidationContext = void 0;
const React = __importStar(require("react"));
const UnsupportedValueError_1 = __importDefault(require("../util/UnsupportedValueError"));
exports.ValidationContext = React.createContext({});
exports.validationActions = {
    // Property
    initialiseProperty: (propertySummary) => ({ type: 'INITIALISE_PROPERTY', payload: propertySummary }),
    updateProperty: (field, valid) => ({ type: 'UPDATE_PROPERTY', payload: { field, valid } }),
    // Images
    initialiseImages: (count, valid) => ({ type: 'INITIALISE_IMAGES', payload: { count, valid } }),
    updateImages: (count, valid) => ({ type: 'UPDATE_IMAGES', payload: { count, valid } }),
    // Customer
    initialiseCustomer: (nameValid, emailValid, phoneValid) => ({ type: 'INITIALISE_CUSTOMER', payload: { name: nameValid, email: emailValid, phone: phoneValid } }),
    updateCustomer: (field, valid) => ({ type: 'UPDATE_CUSTOMER', payload: { field, valid } }),
    bypassCustomer: () => ({ type: 'BYPASS_CUSTOMER' }),
    // Terms
    initialiseTerms: (valid) => ({ type: 'INITIALISE_TERMS', payload: { valid } }),
    updateTerms: (valid) => ({ type: 'UPDATE_TERMS', payload: { valid } }),
    bypassTerms: () => ({ type: 'BYPASS_TERMS' }),
    // Channels
    initialiseChannels: (valid) => ({ type: 'INITIALISE_CHANNELS', payload: { valid } }),
    updateChannels: (valid) => ({ type: 'UPDATE_CHANNELS', payload: { valid } }),
    bypassChannels: () => ({ type: 'BYPASS_CHANNELS' }),
    // Licence
    initialiseLocalLicence: (licenceValidation) => ({ type: 'INITIALISE_LOCAL_LICENCE', payload: licenceValidation }),
    updateLocalLicence: (field, valid) => ({ type: 'UPDATE_LOCAL_LICENCE', payload: { field, valid } }),
    bypassLocalLicence: () => ({ type: 'BYPASS_LOCAL_LICENCE' }),
};
const initialValidationState = () => ({
    property: {
        initialised: false,
        fields: {},
        valid: false,
    },
    images: {
        initialised: false,
        count: 0,
        valid: false,
    },
    customer: {
        initialised: false,
        fields: { name: false, email: false, phone: false },
        valid: false
    },
    channels: {
        initialised: false,
        valid: false
    },
    terms: {
        initialised: false,
        valid: false
    },
    local_licence: {
        initialised: false,
        fields: {},
        valid: false
    }
});
exports.initialValidationState = initialValidationState;
const validationReducer = (state, action) => {
    // Log out actions that are firing when running locally
    if (process.env.LOCAL_DEV) {
        console.debug(action);
    }
    switch (action.type) {
        case 'INITIALISE_PROPERTY': {
            const initPropertyFields = Object.entries(action.payload.validation.property.result).reduce((acc, entry) => {
                return Object.assign(Object.assign({}, acc), { [entry[0]]: entry[1].valid });
            }, {});
            const property = Object.assign(Object.assign({}, state.property), { initialised: true, fields: initPropertyFields, valid: Object.values(initPropertyFields).every((pf) => pf === true) });
            const images = Object.assign(Object.assign({}, state.images), { initialised: true, valid: action.payload.validation.images.valid, count: action.payload.image_count });
            return Object.assign(Object.assign({}, state), { property, images });
        }
        case 'UPDATE_PROPERTY': {
            const updatePropertyFields = Object.assign(Object.assign({}, state.property.fields), { [action.payload.field]: action.payload.valid });
            const property = Object.assign(Object.assign({}, state.property), { fields: updatePropertyFields, valid: Object.values(updatePropertyFields).every((v) => v === true) });
            return Object.assign(Object.assign({}, state), { property });
        }
        case 'INITIALISE_IMAGES':
            return Object.assign(Object.assign({}, state), { images: Object.assign({ initialised: true }, action.payload) });
        case 'UPDATE_IMAGES':
            return Object.assign(Object.assign({}, state), { images: Object.assign(Object.assign({}, state.images), action.payload) });
        case 'INITIALISE_CUSTOMER': {
            const customerInit = Object.assign(Object.assign({}, state.customer), { initialised: true, fields: action.payload, valid: Object.values(action.payload).every((cf) => cf === true) });
            return Object.assign(Object.assign({}, state), { customer: customerInit });
        }
        case 'UPDATE_CUSTOMER':
            const customerUpdate = state.customer;
            customerUpdate.fields[action.payload.field] = action.payload.valid;
            customerUpdate.valid = Object.values(customerUpdate.fields).every((valid) => (valid));
            return Object.assign(Object.assign({}, state), { customer: customerUpdate });
        case 'BYPASS_CUSTOMER':
            return Object.assign(Object.assign({}, state), { customer: { initialised: true, valid: true, fields: { name: true, email: true, phone: true } } });
        case 'INITIALISE_CHANNELS':
            return Object.assign(Object.assign({}, state), { channels: { initialised: true, valid: action.payload.valid } });
        case 'UPDATE_CHANNELS':
            return Object.assign(Object.assign({}, state), { channels: Object.assign(Object.assign({}, state.channels), { valid: action.payload.valid }) });
        case 'BYPASS_CHANNELS':
            return Object.assign(Object.assign({}, state), { channels: { initialised: true, valid: true } });
        case 'INITIALISE_TERMS':
            return Object.assign(Object.assign({}, state), { terms: { initialised: true, valid: action.payload.valid } });
        case 'BYPASS_TERMS':
            return Object.assign(Object.assign({}, state), { terms: { initialised: true, valid: true } });
        case 'UPDATE_TERMS':
            return Object.assign(Object.assign({}, state), { terms: Object.assign(Object.assign({}, state.terms), { valid: action.payload.valid }) });
        case 'BYPASS_LOCAL_LICENCE':
            return Object.assign(Object.assign({}, state), { local_licence: { initialised: true, valid: true, fields: {} } });
        case 'INITIALISE_LOCAL_LICENCE':
            const licenceInit = Object.assign(Object.assign(Object.assign({}, state.local_licence), { initialised: true }), action.payload);
            return Object.assign(Object.assign({}, state), { local_licence: licenceInit });
        case 'UPDATE_LOCAL_LICENCE':
            const licenceUpdatefields = Object.assign(Object.assign({}, state.local_licence.fields), { [action.payload.field]: action.payload.valid });
            const localLicence = Object.assign(Object.assign({}, state.local_licence), { fields: licenceUpdatefields, valid: Object.values(licenceUpdatefields).every((v) => v === true) });
            return Object.assign(Object.assign({}, state), { local_licence: localLicence });
        default: throw new UnsupportedValueError_1.default(action);
    }
};
exports.validationReducer = validationReducer;
//# sourceMappingURL=ValidationContext.js.map